'use client';

import { useEffect, useState } from 'react';

/**
 * Intercom top banners are fixed at the top of the viewport and make room for themselves by setting an
 * inline `margin-top` on `<body>`. Fixed and sticky nav elements pinned to `top: 0` must be offset by
 * that amount, or they slide underneath the banner.
 */
export function useIntercomBannerOffset(): number {
    const [offset, setOffset] = useState(0);

    useEffect(() => {
        const readOffset = (): void => setOffset(parseFloat(document.body.style.marginTop) || 0);
        readOffset();

        const observer = new MutationObserver(readOffset);
        observer.observe(document.body, { attributes: true, attributeFilter: ['style'] });

        return (): void => observer.disconnect();
    }, []);

    return offset;
}
